//separator for all numbers should always be ',', do not change
const formatNumberWithoutFixing = number =>
	Number(number)
		.toString()
		.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

export default formatNumberWithoutFixing;
